import apiClient from "@/api/client";
import type { PockRequest } from "@/features/orders/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export interface PockRequestItemPayload {
  order_line_item: string;
  /** What the contractor typed — the server derives the percentage from it. */
  accepted_quantity: string;
  /** Same quantity as a percentage, for a backend that predates accepted_quantity. */
  completion_percentage: string;
}

export const pockRequestsApi = {
  list: (params?: Record<string, string>) =>
    apiClient.get<{ data: PockRequest[] }>("/protocols/pock-requests/", { params }).then(wrap),

  create: (data: { order: string; note?: string; proposed_settlement_pct?: string; proposed_is_final?: boolean; items: PockRequestItemPayload[] }) =>
    apiClient.post<{ data: PockRequest }>("/protocols/pock-requests/", data).then(wrap),

  approve: (id: string, comment?: string, approved_settlement_pct?: string, is_final?: boolean) =>
    apiClient
      .post<{ data: PockRequest }>(`/protocols/pock-requests/${id}/approve/`, {
        comment: comment ?? "",
        approved_settlement_pct: approved_settlement_pct ?? "100",
        is_final: is_final ?? false,
      })
      .then(wrap),

  reject: (id: string, comment?: string) =>
    apiClient
      .post<{ data: PockRequest }>(`/protocols/pock-requests/${id}/reject/`, { comment: comment ?? "" })
      .then(wrap),

  withdraw: (id: string) =>
    apiClient.post<{ data: PockRequest }>(`/protocols/pock-requests/${id}/withdraw/`, {}).then(wrap),

  /** Files of the whole request (not of one line) — copied onto the POCK on approval. */
  uploadDocumentAttachments: (requestId: string, files: File[]) => {
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    return apiClient.post(`/protocols/pock-requests/${requestId}/attachments/`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  uploadItemAttachments: (requestId: string, itemId: string, files: File[]) => {
    const fd = new FormData();
    files.forEach((f) => fd.append("attachments", f));
    return apiClient.post(`/protocols/pock-requests/${requestId}/items/${itemId}/attachments/`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
